import { OrderedSet } from "immutable";
import colorDataDefaults from "./../ricos-schema/legacy/statics/color.defaults.json";
import { Mark_Type } from "./../ricos-types";
import { createRicosMarkExtension } from "./../plugin-commons";
import { BACKGROUND_COLOR } from "./dataHooks";
const tiptapColorBackgroundExtension = createRicosMarkExtension({
  type: "mark",
  name: Mark_Type.COLOR_BACKGROUND,
  groups: [],
  reconfigure: (config, _extensions, _props, settings) => ({
    ...config,
    addOptions() {
      return {
        HTMLAttributes: {},
        ...settings
      };
    }
  }),
  createExtensionConfig() {
    return {
      name: this.name,
      addAttributes() {
        return {
          color: { default: colorDataDefaults.background }
        };
      },
      parseHTML() {
        return [
          {
            style: "background-color",
            getAttrs: (color) => ({ color })
          }
        ];
      },
      renderHTML({ HTMLAttributes: { color } }) {
        const backgroundColor = this.options.styleSelectionPredicate?.(color) ? this.options.customStyleFn?.(OrderedSet([color]))?.backgroundColor : color;
        return [
          "span",
          {
            "data-hook": BACKGROUND_COLOR,
            style: `background-color: ${backgroundColor}; text-decoration: inherit;`
          }
        ];
      },
      addCommands() {
        return {
          setHighlight: (color) => ({ commands }) => commands.setMark(this.name, { color }),
          unsetHighlight: () => ({ commands }) => commands.setMark(this.name, { color: null })
        };
      }
    };
  }
});
export {
  tiptapColorBackgroundExtension
};
//# sourceMappingURL=tiptap-background.js.map
